/** The country code a phone field starts with, guessed from the interface language. */
const getInitialPhoneCodeByLocale = (locale: string) => {
  switch (locale) {
    case 'ru':
      return '+7';
    case 'fr':
      return '+33';
    default:
      return '+44';
  }
};

export { getInitialPhoneCodeByLocale };
